import React from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import NewUserPage from "./components/new_user_page";
import FormSubmitted from "./components/form_submitted";
import Layout from "./components/layout";
import Dashboard from "./components/dashboard";
import Referrals from "./components/referrals";
import Settings from "./components/settings";
import Payouts from "./components/payouts";
import AffiliateLinks from "./components/affiliate_links";
import Help from "./components/help";
import Visitors from "./components/visitors";
import Promotions from "./components/promotions";

const AppRoutes = (props) => {
  const { signUp, admin_review, promotions } = props;

  const { pathname } = useLocation();

  // The promotions dashboard is a separate admin surface: it is not scoped to one referrer, so it
  // does not share the partner layout or its sidebar.
  if (promotions) {
    return (
      <Routes>
        <Route path="/promotions/*" element={<Promotions {...props} />} />
      </Routes>
    );
  }
  const subRoutes = <>
    <Route path="dashboard" element={<Dashboard {...props} />} />
    {
      admin_review &&
      <>
        <Route path="referrals" element={<Referrals />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="affiliate-links" element={<AffiliateLinks />} />
        <Route path="visitors" element={<Visitors />} />
      </>
    }
    <Route path="settings" element={<Settings />} />
    <Route path="help" element={<Help />} />
    {/* Wildcard route to catch unmatched paths */}
    <Route path="*" element={<Navigate to="/partners/dashboard" replace />} />
  </>;

  const mainRoute = pathname.includes("admin") ?
    <Route path="/admin/:referrer_id" element={<Layout {...props} />} >
      <Route index element={<Navigate to="dashboard" replace />} />
      {subRoutes}
    </Route> :
    <Route path="/partners" element={<Layout {...props} />} >
      {subRoutes}
    </Route>;

  return (
    <div>
      {signUp ?
        <Routes>
          <Route path="/" element={<NewUserPage />} />
          <Route path="/sign_up" element={<NewUserPage />} />
          <Route path="/partners/sign_up" element={<NewUserPage />} />
          <Route path="/partners/form-submit" element={<FormSubmitted />} />
          <Route path="*" element={<Navigate to="/partners/dashboard" replace />} />
        </Routes> :
        <Routes>
          {mainRoute}
          <Route path="*" element={<Navigate to="/partners/dashboard" replace />} />
        </Routes>
      }
    </div>
  );
};

AppRoutes.propTypes = {
  signUp: PropTypes.bool,
  admin_review: PropTypes.bool,
  promotions: PropTypes.bool,
};

export default AppRoutes;
